import styleVariables from '!!dart-sass-variable-loader!../../scss/variables/_colors.scss';

export default class StyleVariables {
	static install(Vue, options) {
		Vue.themeColors = Vue.prototype.$themeColors = styleVariables;
	}
}